import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { TrainerDashboardLayout } from './dashboard/TrainerDashboardLayout';
import { ClientManagement } from './clients/ClientManagement';
import { WorkoutLibrary } from './workouts/WorkoutLibrary';
import { TrainerAnalytics } from './analytics/TrainerAnalytics';
import { TrainerSettings } from './settings/TrainerSettings';
import { useProfileStore } from '../../store/profileStore';

export function TrainerApp() {
  const { isTrainerMode } = useProfileStore();

  if (!isTrainerMode) {
    return <Navigate to="/home" replace />;
  }

  return (
    <Routes>
      <Route path="/" element={<TrainerDashboardLayout />} />
      <Route path="/trainer" element={<TrainerDashboardLayout />} />
      <Route path="/clients" element={<ClientManagement />} />
      <Route path="/workouts" element={<WorkoutLibrary />} />
      <Route path="/analytics" element={<TrainerAnalytics />} />
      <Route path="/settings" element={<TrainerSettings />} />
      <Route path="*" element={<Navigate to="/trainer" replace />} />
    </Routes>
  );
}